import { Component } from '@angular/core';

import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { scrollToTop } from '@gallaghercp/core-frontend';
import { throwError } from 'rxjs';
import { RegisterComponent } from '../register/register.component';

@Component({
    selector: 'core-reset-request',
    templateUrl: './reset-request.component.html',
    standalone: false,
})
export class ResetRequestComponent extends RegisterComponent {
    resetForm = new UntypedFormGroup({
        email: new UntypedFormControl('', [Validators.required, Validators.email]),
    });

    reset() {
        this.submitting = true;
        this.errorMessage = false;
        this.spinner.show('reset');

        const data = {
            username: this.resetForm.get('email')!.value,
        };

        return this.subscriptions.push(
            this.api.post('password-reset-request', data).subscribe(
                () => {
                    scrollToTop(500);
                    this.spinner.hide('reset');
                    this.submitting = false;
                    this.successMessage = `If your email address is recognised, password reset instructions will be sent to you shortly.`;
                    this.resetForm.reset();
                },
                error => {
                    scrollToTop(500);
                    this.spinner.hide('reset');
                    this.submitting = false;
                    this.errorMessage = `<p>Your reset attempt failed, please check the information you entered and try again.</p>
                                    <p>Error reference: ${error.headers.get('x-service-request-id')}</small></p>`;
                    return throwError(`Error Code: ${error.status}\nMessage: ${error.message}`);
                },
            ),
        );
    }
}
